import Vue from 'vue'

export async function getCaminos(context, [access_token, con_loading]) {

    try {
        if (access_token) {
            if (con_loading) {
                context.commit('setLoading', true, { root: true })
            }
            const response = await Vue.axios({
                method: 'GET',
                url: '/caminos',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
            })
            context.commit('caminos/setCaminos', response.data.data, { root: true })
        }

    } catch (e) {
    } finally {
        if (con_loading) {
            context.commit('setLoading', false, { root: true })
        }
    }
}


export async function getCamino(context, [access_token, id, con_loading]) {

    try {
        if (access_token) {
            if (con_loading) {
                context.commit('setLoading', true, { root: true })
            }
            const response = await Vue.axios({
                method: 'GET',
                url: '/caminos/' + id,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
            })
            if (response.status == 200) {
                context.commit('caminos/setCaminoSelec', response.data.data, { root: true })
            }
        }

    } catch (e) {
    } finally {
        if (con_loading) {
            context.commit('setLoading', false, { root: true })
        }
    }
}

export async function crearCamino(context, [access_token, modelCamino]) {
    try {

        if (access_token) {
            // context.commit('setLoading', true, { root: true })
            const response = await Vue.axios({
                method: 'POST',
                url: '/caminos',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: modelCamino
            })
        }

    } catch (e) {
    } finally {
        //  context.commit('setLoading', false, { root: true })
    }
}

export async function updateCamino(context, [access_token, modelCamino]) {
    try {
        if (access_token) {

            const response = await Vue.axios({
                method: 'PUT',
                url: '/caminos/' + modelCamino.id,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: modelCamino
            })
            if (response.status == 200) {
                context.commit('caminos/actListCaminos', response.data.data, { root: true })
                context.commit('categorias/actListCaminosFromCategorias', response.data.data, { root: true })
            }
            return response;
            // context.commit('reservas/setDisponibilidadAnual', response.data, { root: true })
        }

    } catch (e) {
    } finally {
        // context.commit('setLoading', false, { root: true })
    }
}

export async function eliminarCamino(context, [access_token, camino_id]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'DELETE',
                url: '/caminos/' + camino_id,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
            })
            if (response.status == 200) {
                context.commit('caminos/actDeleteListCaminos', camino_id, { root: true })
                context.commit('categorias/actDeleteListCaminosFromCategorias', camino_id, { root: true })

            }
            return response;
        }
    } catch (e) {
    } finally {
        // context.commit('setLoading', false, { root: true })
    }
}

export async function createTarifa(context, [access_token, modelTarifa]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'POST',
                url: '/camino-tarifas',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: modelTarifa
            })
            if ((response.status == 200 || response.status == 201) && response.data.tarifa) {
                context.commit('caminos/actAddListTarifas', response.data.tarifa, { root: true })
                return response.data.tarifa;
            }
            return null;;
        }
    } catch (e) {
        return null;
    }
}

export async function deleteTarifa(context, [access_token, tarifa_id]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'DELETE',
                url: '/camino-tarifas/' + tarifa_id,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
            })
            if (response.status == 200) {
                context.commit('caminos/actDeleteListTarifas', tarifa_id, { root: true })
            }
            return response;
        }
    } catch (e) {
        return null;
    }
}

export async function updateTarifa(context, [access_token, modelTarifa]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'PUT',
                url: '/camino-tarifas/' + modelTarifa.id,
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: modelTarifa
            })
            if (response.status == 200) {
                context.commit('caminos/actUpdateListTarifas', response.data.tarifa, { root: true })
                return response.data.tarifa;
            }
            return null;
        }
    } catch (e) {
        return null;
    }
}

export async function duplicarCamino(context, [access_token, camino_id, categoria_id, titulo, titulo_EN, titulo_DE]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'POST',
                url: '/duplicar-camino',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: {
                    camino_id: camino_id,
                    categoria_id: categoria_id,
                    titulo: titulo,
                    titulo_EN: titulo_EN,
                    titulo_DE: titulo_DE,
                }
            })
            if (response.status == 200 || response.status == 201) {
                return response.data.data;
            }
            return null;
        }
    } catch (e) {
        return null;
    }
}

export async function eliminarEtapasCamino(context, [access_token, camino_id, etapa_id]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'POST',
                url: '/eliminar-etapa',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: {
                    camino_id: camino_id,
                    etapa_id: etapa_id,
                }
            })
            if (response.status == 200 || response.status == 201) {
                context.commit('caminos/actDeleteListEtapas', etapa_id, { root: true })
                return response.data.data;
            }
            return null;
        }
    } catch (e) {
        return null;
    }
}


export async function updateCaminoConEtapaFinal(context, [access_token, camino_id, con_etapa_final]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'POST',
                url: '/update-camino-con-etapa-final',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: {
                    camino_id: camino_id,
                    con_etapa_final: con_etapa_final,
                }
            })
            if (response.status == 200) {
                return response.data.data;
            }
            return null;
        }
    } catch (e) {
        return null;
    }
}

export async function updateServicioHabilitadoCliente(context, [access_token, camino_id, servicio_id, habilitado]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'POST',
                url: '/update-servicio-habilitado-cliente',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: {
                    camino_id: camino_id,
                    servicio_id: servicio_id,
                    esta_habilitado: habilitado,
                }
            })
            console.log('responseupdateServicioHabilitadoCliente:', response);
            if (response.status == 200) {
                return response.data.data;
            }
            return null;
        }
    } catch (e) {
        return null;
    }
}

export async function updateServicioActivo(context, [access_token, camino_id, servicio_id, activo]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'POST',
                url: '/update-servicio-activo',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: {
                    camino_id: camino_id,
                    servicio_id: servicio_id,
                    esta_activo: activo,
                }
            })
            console.log('responseupdateServicioActivo:', response);
            if (response.status == 200) {
                return response.data.data;
            }
            return null;
        }
    } catch (e) {
        return null;
    }
}

export async function updateEtapaOrden(context, [access_token, camino_id, etapa_id, accion]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'POST',
                url: '/update-etapa-orden',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: {
                    camino_id: camino_id,
                    etapa_id: etapa_id,
                    accion: accion,
                }
            })
            console.log('responseupdateEtapaOrden:', response);
            if (response.status == 200) {
                return response.data.data;
            }
            return null;
        }
    } catch (e) {
        return null;
    }
}

export async function agregarEtapaExistente(context, [access_token, camino_id, etapa_id]) {
    try {
        if (access_token) {
            const response = await Vue.axios({
                method: 'POST',
                url: '/agregar-etapa-existente',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                    'Authorization': 'Bearer ' + access_token,
                },
                data: {
                    camino_id: camino_id,
                    etapa_id: etapa_id,
                }
            })
            if (response.status == 200) {
                return response.data.data;
            }
            return null;
        }
    } catch (e) {
        return null;
    }
}